import { render } from "./RadioComponent.vue?vue&type=template&id=08c4fd26&ts=true"
import script from "./RadioComponent?vue&type=script&lang=ts"
export * from "./RadioComponent?vue&type=script&lang=ts"

import "./_assets/_radio.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__